import axios from "axios";

// Use environment variable so dev/prod can differ
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://127.0.0.1:8000",
});

export default api;
